import React from 'react';
import { Box, TextField } from '@mui/material';
import { IFilterValueSelectorProps } from './interfaces';
import { useGetAllPreferences } from '../../../services/react-query/preferences';
import { Preference, PREFERENCES_VALID_KEYS } from '../../../types/Preference';
import PreferencePicker from '../../preferences/picker/PreferencePicker';
import { uuidFinder } from '../../../utility/inputUtils';

export default function TagFilterSelector({ filterValues, setFilterValues }: IFilterValueSelectorProps) {
  const setPreferenceUuid = (preferenceUuid: string | null) => setFilterValues([preferenceUuid, filterValues[1]]);
  const setText = (text: string) => setFilterValues([filterValues[0], text]);

  const { data: preferences, isLoading } = useGetAllPreferences({
    params: { filters: { keys: [PREFERENCES_VALID_KEYS.TAG] } },
  });

  if (!preferences) return null;

  const selectedPref: Preference | null = (uuidFinder(preferences, filterValues[0]) as Preference | null) ?? null;

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <PreferencePicker
        fullWidth
        label="Tag Preference"
        options={preferences}
        loading={isLoading}
        value={selectedPref}
        onValueChange={(val) => setPreferenceUuid((val as Preference | null)?.uuid ?? null)}
        disableClearable={false}
      />

      <TextField fullWidth label="Tag Text" size="small" onChange={(e) => setText(e.target.value)} value={filterValues[1] ?? ''} />
    </Box>
  );
}
